module.exports = __webpack_public_path__ + "public/img/logo.a4c4a209.png";